module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/aspin19-a2630bea1ef73b00263ec9cc60aceec6.jpg";